export class PlanRenameResult {

    success: boolean = false;
    errorMessage?: string;
    data: string = '';
    lastEdited!: Date;

    constructor() {}

}
